<template>
    <div class="CheckoutContainer">

        <div class="LinkContainer" v-show="is_active == true">
            <a :href="'#/checkout/' + module_id">
                <button class="btn btn-default checkout">{{ $t('product.cta_checkoutpage') }}</button>
            </a>
        </div>

        <p v-show="is_active == false">{{ $t('cart.warning_empty') }}</p>

        <div class="CtaList">
            <a @click="$router.push({name: 'List', params: { module_id: active_module.module_id, scrollParent: true }})">{{ $t('cart.cta_goback') }}</a>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {

    props: [
      'module_id',
      'is_active'
    ],

    computed: {
      ...mapGetters([
        'active_module',
      ]),
    },
  };
</script>

<style>

    .CheckoutContainer {
        margin-top: 5%;
        padding: 5%;
        border: 1px solid #ddd;
    }

    .CheckoutContainer .product--cart__inner {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -ms-flex-align: center;
        align-items: center;
    }

    .CheckoutContainer .product--cart__total {
        border-top: 1px solid #ddd;
        padding-top: 2%;
        font-size: 18px;
        color: #4B77BE;
    }

    .LinkContainer {
        /*width: 80%;*/
    }

    /*
    .product--cart .LinkContainer {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: distribute;
        justify-content: space-around;
    }
    */

    .CheckoutContainer .LinkContainer button {
        font-weight: 200;
        width: 100%;
        color: #000;
        font-weight: 400;
        border-color: #a88734 #9c7e31 #846a29;
        box-shadow: 0 1px 0 rgba(255, 255, 255, 0.4) inset;
        background: linear-gradient(to bottom, #f7dfa5, #f0c14b);
    }

    .CtaList {
        margin-top: 10px;

        cursor: pointer;
    }

    @media screen and (max-width: 991px) {
        .CheckoutContainer .LinkContainer .btn {
            padding: 4px 10px;
        }
    }

</style>



// WEBPACK FOOTER //
// go-checkout.vue?8fbd10a2